export enum ShiftPaymentStrategy {
    shiftOnly = 'shift_only',
    bookingsOnly = 'bookings_only',
    bookingsAndShift = 'bookings_and_shift',
}
